'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  gap: 8px;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  gap: 8px;\n  ", ";\n  ", ";\n"])), function (_a) {
    var isStretched = _a.isStretched;
    return isStretched && 'align-items: stretch';
}, function (_a) {
    var keyButtonPosition = _a.keyButtonPosition;
    return ['top', 'bottom'].includes(keyButtonPosition) && 'flex-direction: column';
});
var ButtonGroup = function (_a) {
    var _b = _a.keyButtonPosition, keyButtonPosition = _b === void 0 ? 'left' : _b, _c = _a.isStretched, isStretched = _c === void 0 ? false : _c, buttons = _a.buttons, children = _a.children, rest = tslib_es6.__rest(_a, ["keyButtonPosition", "isStretched", "buttons", "children"]);
    var isReversed = ['right', 'bottom'].includes(keyButtonPosition);
    return (React__default.createElement(Container, tslib_es6.__assign({ keyButtonPosition: keyButtonPosition, isStretched: isStretched }, rest),
        buttons && (isReversed ? tslib_es6.__spread(buttons).reverse() : buttons).map(function (button$1) { return (React__default.createElement(button.Button, tslib_es6.__assign({ key: button$1.text }, button$1))); }),
        children));
};
var templateObject_1;

exports.ButtonGroup = ButtonGroup;
